import React, { useEffect, useState } from 'react';
import { deleteFaq, loadFaqs, setFaqSortOrder } from '../utils/Network';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { isAdmin } from '../utils';

const FAQ_PAGE_SIZE = 50;

export default function FaqsContent({ page, urlParams }) {
    const queryPage = Math.max(
        1,
        Number(new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '').get('page')) || 1
    );
    const pathPage =
        page != null && page !== '' && !Number.isNaN(Number(page)) ? Math.max(1, Math.floor(Number(page))) : null;
    const currentPage = pathPage != null ? pathPage : queryPage;
    const [loading, setLoading] = useState(0);
    const [pageloading, setPageLoading] = useState(false);
    const [faqs, setFaqs] = useState(null);
    const [faqs_count, setFaqsCount] = useState(null);
    const [show_delete, setShowDelete] = useState(false);
    const [pages, setPages] = useState(null);
    const [filter_question, setFilterQuestion] = useState(() => urlParams.get('question') || '');

    const locationKey =
        typeof window !== 'undefined' ? `${window.location.pathname}${window.location.search}` : '';

    useEffect(() => {
        const q = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '').get(
            'question'
        );
        setFilterQuestion(q || '');
        setPageLoading(true);
        getFaqs();
    }, [locationKey, currentPage]);

    function getFaqs() {
        const filter_query = typeof window !== 'undefined' ? window.location.search || '' : '';
        loadFaqs(filter_query, currentPage).then((data) => {
            if (data.results) {
                setFaqs(data.results);
            }
            const totalCount = Number(data.count) || 0;
            setFaqsCount(totalCount);
            if (totalCount > 0) {
                const pageCount = Math.ceil(totalCount / FAQ_PAGE_SIZE);
                setPages(range(1, pageCount));
            } else {
                setPages([]);
            }
            setPageLoading(false);
        });
    }

    function range(start, end) {
        return Array.apply(0, Array(end)).map((element, index) => index + start);
    }

    const handleDelete = (id) => {
        setLoading(id);
        deleteFaq(id).then(() => {
            getFaqs();
        });
    };

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete);
    };

    const onChangeQuestion = (e) => {
        setFilterQuestion(e.target.value);
    };

    const onDragEnd = (result) => {
        const { destination, source, draggableId } = result;

        if (!destination) return;
        if (destination.index === source.index) return;

        const draggedFaq = faqs.find((x) => String(x.id) === String(draggableId));
        if (!draggedFaq) return;

        const temp = [...faqs];
        temp.splice(source.index, 1);
        temp.splice(destination.index, 0, draggedFaq);

        const ids = [];
        temp.forEach((child) => {
            ids.push(child.id);
        });

        setFaqSortOrder(ids);
        setFaqs(temp);
    };

    const totalPages = pages?.length || 0;
    const canGoPrev = totalPages > 0 && currentPage > 1;
    const canGoNext = totalPages > 0 && currentPage < totalPages;

    const queryString = (() => {
        const p = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
        p.delete('page');
        const s = p.toString();
        return s ? `?${s}` : '';
    })();

    const hasQuestionFilter = Boolean(
        (filter_question && String(filter_question).trim()) ||
            (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('question'))
    );

    const getLocalizedQuestion = (faqItem) => {
        const lang = faqItem.language;
        const localizedName = faqItem.names?.find(
            (name) => parseInt(name.language, 10) === parseInt(lang, 10)
        );
        return localizedName?.question || faqItem.question;
    };

    return (
        <>
            <div className="content-wrapper cms-ratings-surface">
                <section className="content padding-top-sm-0">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box box-primary">
                                    <div className="box-header with-border clearfix">
                                        <h3 className="box-title">
                                            All faqs{' '}
                                            {faqs_count != null && (
                                                <span style={{ fontSize: 11 }}>({faqs_count})</span>
                                            )}
                                        </h3>
                                        <div
                                            className="pull-right"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                flexWrap: 'wrap',
                                                maxWidth: 'min(100%, 720px)',
                                            }}
                                        >
                                            <form
                                                method="get"
                                                action="/cms/faqs"
                                                className="form-inline"
                                                style={{ marginBottom: 0, display: 'flex', alignItems: 'center', gap: '8px' }}
                                            >
                                                <input
                                                    name="question"
                                                    className="form-control"
                                                    type="search"
                                                    placeholder="Search questions…"
                                                    value={filter_question}
                                                    onChange={onChangeQuestion}
                                                    style={{ minWidth: '200px', maxWidth: '280px', width: '36vw' }}
                                                    autoComplete="off"
                                                />
                                            </form>
                                            {hasQuestionFilter && (
                                                <a href="/cms/faqs" className="btn btn-default btn-sm mt-2p">
                                                    Clear
                                                </a>
                                            )}
                                            {isAdmin() && (
                                                <>
                                                    <button
                                                        type="button"
                                                        title="Show Delete Button"
                                                        className="btn btn-cm margin-r-5 "
                                                        onClick={showDelete}
                                                    >
                                                        <i className="fa fa-trash" />
                                                    </button>
                                                    <a
                                                        href="/cms/faq"
                                                        title="Add New"
                                                        className="btn btn-cm margin-r-5 "
                                                    >
                                                        <i className="fa fa-plus" />
                                                    </a>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="box-body no-padding">
                                        <DragDropContext onDragEnd={onDragEnd}>
                                            <table
                                                id="example1"
                                                className={`table table-striped cms-list-table cms-draggable-list-rows cms-faqs-table mb-0${pageloading ? ' opacity-70' : ''}`}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th style={{ width: 120 }} />
                                                    </tr>
                                                </thead>
                                                <Droppable droppableId="dopaable">
                                                    {(dropProvided) => (
                                                        <tbody
                                                            ref={dropProvided.innerRef}
                                                            {...dropProvided.droppableProps}
                                                        >
                                                            {faqs &&
                                                                faqs.map((item, index) => (
                                                                    <Draggable
                                                                        key={item.id}
                                                                        draggableId={`${item.id}`}
                                                                        index={index}
                                                                    >
                                                                        {(provided) => (
                                                                            <tr
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                                ref={provided.innerRef}
                                                                                className={loading === item.id ? 'jd loading' : 'jd'}
                                                                            >
                                                                                <td>
                                                                                    <a className="kfont" href={`/cms/faq/${item.id}`}>
                                                                                        {getLocalizedQuestion(item)}
                                                                                    </a>
                                                                                </td>
                                                                                
                                                                                <td className="cms-faqs-actions-cell">
                                                                                    <div className="btn-group cms-row-actions cms-faqs-actions-group">
                                                                                        {show_delete && (
                                                                                            <button
                                                                                                type="button"
                                                                                                onClick={() => {
                                                                                                    if (
                                                                                                        window.confirm(
                                                                                                            'Are you sure you wish to delete this item?'
                                                                                                        )
                                                                                                    ) {
                                                                                                        handleDelete(item.id);
                                                                                                    }
                                                                                                }}
                                                                                                className="btn btn-default btn-sm cms-row-action-btn cms-row-action-btn-danger"
                                                                                            >
                                                                                                <i className="fa fa-trash"></i>
                                                                                            </button>
                                                                                        )}
                                                                                        <a
                                                                                            href={`/cms/faq/${item.id}`}
                                                                                            className="btn btn-default btn-sm cms-row-action-btn"
                                                                                        >
                                                                                            <i className="fa fa-edit"></i>
                                                                                        </a>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </Draggable>
                                                                ))}
                                                            {dropProvided.placeholder}
                                                        </tbody>
                                                    )}
                                                </Droppable>
                                            </table>
                                        </DragDropContext>
                                        {!faqs?.length && !pageloading && (
                                            <div className="padding-10 text-muted">No faqs found.</div>
                                        )}
                                    </div>
                                </div>
                                {totalPages > 1 && (
                                    <ul className="pagination cms-pagination m-0 float-right">
                                        <li className={`page-item${!canGoPrev ? ' disabled' : ''}`}>
                                            <a
                                                className="page-link"
                                                href={
                                                    canGoPrev
                                                        ? `/cms/faqs/${currentPage - 1}${queryString ? `${queryString}` : ''}`
                                                        : '#'
                                                }
                                                onClick={!canGoPrev ? (e) => e.preventDefault() : undefined}
                                                aria-disabled={!canGoPrev}
                                            >
                                                «
                                            </a>
                                        </li>
                                        {pages &&
                                            pages.map((page_number) => (
                                                <li key={page_number} className="page-item">
                                                    <a
                                                        className={page_number === currentPage ? 'page-link active' : 'page-link'}
                                                        href={`/cms/faqs/${page_number}${queryString ? `${queryString}` : ''}`}
                                                    >
                                                        {page_number}
                                                    </a>
                                                </li>
                                            ))}
                                        <li className={`page-item${!canGoNext ? ' disabled' : ''}`}>
                                            <a
                                                className="page-link"
                                                href={
                                                    canGoNext
                                                        ? `/cms/faqs/${currentPage + 1}${queryString ? `${queryString}` : ''}`
                                                        : '#'
                                                }
                                                onClick={!canGoNext ? (e) => e.preventDefault() : undefined}
                                                aria-disabled={!canGoNext}
                                            >
                                                »
                                            </a>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </div>
                </section>
            </div>
        </>
    );
}
